import { Button, Stack } from '@mui/material';
import React from 'react';
import { Control, FieldPath } from 'react-hook-form';

import {
  OldPrejudiceFormPerteGainProfessionnelsActuel,
  PrejudiceType,
} from '@norma/shared/types/prejudice.type';
import { ComputedPropsForm } from 'src/components/forms/ComputedPropsForm';
import { PredefinedDatePickerForm } from 'src/components/forms/PredefinedDatePickerForm';

interface Props {
  control: Control<OldPrejudiceFormPerteGainProfessionnelsActuel>;
  dateConsolidation: Date | undefined;
  dateAccident: Date | undefined;
  dateLiquidation: Date | undefined;
  prejudiceType: PrejudiceType;
  isPGPF?: boolean;
  validate: (
    fieldsToValidate: FieldPath<OldPrejudiceFormPerteGainProfessionnelsActuel>[],
  ) => void;
  onPrevious?: () => void;
}

export const PeriodeStep: React.FC<Props> = ({
  control,
  dateConsolidation,
  dateAccident,
  dateLiquidation,
  prejudiceType,
  isPGPF,
  validate,
  onPrevious,
}) => (
  <>
    <Stack direction="row" justifyContent="space-evenly">
      <PredefinedDatePickerForm
        control={control}
        name="dateDebut"
        label="Date de début"
        TextFieldProps={{
          InputLabelProps: { shrink: true },
          sx: {
            minWidth: 155,
            width: 155,
          },
        }}
        minDate={isPGPF ? dateConsolidation : dateAccident}
        disabled={isPGPF && !!dateConsolidation}
        procedure={{
          dateConsolidation: dateConsolidation
            ? dateConsolidation.toISOString()
            : null,
          dateLiquidation: dateLiquidation
            ? dateLiquidation.toISOString()
            : null,
        }}
        victime={{
          dateDeces: null,
          dateAccident: dateAccident ? dateAccident.toISOString() : null,
        }}
        prejudiceType={prejudiceType}
      />
      <PredefinedDatePickerForm
        control={control}
        name="dateFin"
        label="Date de fin"
        TextFieldProps={{
          InputLabelProps: { shrink: true },
          sx: {
            minWidth: 155,
            width: 155,
          },
        }}
        minDate={dateAccident}
        maxDate={
          isPGPF ? dateLiquidation : dateConsolidation || dateLiquidation
        }
        procedure={{
          dateConsolidation: dateConsolidation
            ? dateConsolidation.toISOString()
            : null,
          dateLiquidation: dateLiquidation
            ? dateLiquidation.toISOString()
            : null,
        }}
        victime={{
          dateDeces: null,
          dateAccident: dateAccident ? dateAccident.toISOString() : null,
        }}
        prejudiceType={prejudiceType}
      />
    </Stack>
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={2}
    >
      {!isPGPF && onPrevious && (
        <Button
          variant="outlined"
          color="primary"
          sx={{ alignSelf: 'center' }}
          onClick={onPrevious}
        >
          Précédent
        </Button>
      )}
      <ComputedPropsForm
        control={control}
        watchFields={['dateDebut', 'dateFin']}
        compute={([dateDebut, dateFin]) => ({
          props: {
            dateDebut,
            dateFin,
          },
        })}
        render={({ dateDebut, dateFin }) => (
          <Button
            variant="contained"
            sx={{ alignSelf: 'center' }}
            onClick={() => validate(['dateDebut', 'dateFin'])}
            disabled={!dateDebut || !dateFin}
          >
            Valider
          </Button>
        )}
      />
    </Stack>
  </>
);
